/**
 * FAQ Widget — accordion via <details>/<summary>
 * ================================================
 * Animates the answer panel open/close by interpolating its
 * scrollHeight so it grows/shrinks smoothly instead of jumping.
 * The chevron icon rotates 180° when open.
 */

// Duration of the open/close animation in milliseconds
const DURATION = 300;

/**
 * Animate a single <details> element open or closed.
 *
 * @param {HTMLDetailsElement} details
 * @param {boolean} open - true = opening, false = closing
 */
function animateDetails( details, open ) {
    const answer = details.querySelector( '.faq-widget__answer' );

    if ( ! answer ) {
        return;
    }

    // Cancel any animation that is already running on this element
    if ( details._animation ) {
        details._animation.cancel();
    }

    // When opening we need the element in the DOM first so we can read its height
    if ( open ) {
        details.open = true;
    }

    const fullHeight = answer.scrollHeight + 'px';

    details._animation = answer.animate(
        [
            { height: open ? '0px' : fullHeight, opacity: open ? 0 : 1 },
            { height: open ? fullHeight : '0px', opacity: open ? 1 : 0 },
        ],
        { duration: DURATION, easing: 'ease' }
    );

    details._animation.onfinish = () => {
        details._animation = null;
        answer.style.height = '';

        // Remove the open attribute after the close animation finishes
        if ( ! open ) {
            details.open = false;
        }
    };
}

/**
 * Attach click handler to every <details> inside a FAQ widget.
 *
 * @param {HTMLElement} widget
 */
function initFaqWidget( widget ) {
    widget.querySelectorAll( '.faq-widget__item' ).forEach( ( details ) => {
        const summary = details.querySelector( 'summary' );

        if ( ! summary ) {
            return;
        }

        summary.addEventListener( 'click', ( e ) => {
            // Prevent the browser's native toggle so we control it ourselves
            e.preventDefault();

            const isOpen = details.open;

            // Close all other open items in this widget before opening a new one
            if ( ! isOpen ) {
                widget.querySelectorAll( '.faq-widget__item[open]' ).forEach( ( openDetails ) => {
                    if ( openDetails !== details ) {
                        animateDetails( openDetails, false );
                    }
                } );
            }

            animateDetails( details, ! isOpen );
        } );
    } );
}

// In the Elementor editor, open all items so the editor can see and edit them
if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
    document.querySelectorAll( '.faq-widget__item' ).forEach( ( details ) => {
        details.open = true;
    } );
} else {
    // Initialise all FAQ widgets already in the DOM
    document.querySelectorAll( '[data-faq-accordion]' ).forEach( initFaqWidget );
}

